import React, { useEffect, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { SettingsButton } from './SettingsButton/SettingsButton';
import { SettingsPopover } from './SettingsPopover/SettingsPopover';
import { SettingsContext } from '../providers/SettingsProvider';
import { useOutsideClick } from '../hooks/useOutsideClick';
const useQuality = (props, closePopover) => {
  const {
    selectedQuality,
    qualities,
    onQualityChange,
    config
  } = props;
  const setQualityLevel = useCallback(level => {
    const nextQuality = qualities.find(q => q.level === level);
    if (nextQuality) {
      onQualityChange(nextQuality);
    }
    closePopover();
  }, [closePopover, onQualityChange, qualities]);
  return config.qualityEnabled && qualities.length > 1 && selectedQuality ? {
    selectedQuality,
    qualities,
    setQualityLevel
  } : undefined;
};
const usePlaybackRate = (props, closePopover) => {
  const {
    onSpeedChange
  } = props;
  const [playbackRate, setRate] = useState(1);
  const setPlaybackRate = useCallback(value => {
    setRate(value);
    onSpeedChange(value);
    closePopover();
  }, [closePopover, onSpeedChange]);
  return {
    playbackRate,
    setPlaybackRate
  };
};
const useVisibility = (onPopoverVisibilityChange, mainUIVisible) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const setVisibility = useCallback(isOpen => {
    setPopoverOpen(isOpen);
    if (onPopoverVisibilityChange) {
      onPopoverVisibilityChange(isOpen);
    }
  }, [onPopoverVisibilityChange]);
  const closePopover = useCallback(() => setVisibility(false), [setVisibility]);
  const togglePopover = useCallback(() => setVisibility(!isPopoverOpen), [isPopoverOpen, setVisibility]);
  useEffect(() => {
    if (!mainUIVisible) {
      setVisibility(false);
    }
  }, [mainUIVisible, setVisibility]);
  return {
    setVisibility,
    closePopover,
    isPopoverOpen,
    togglePopover
  };
};
export const ModuleUI = props => {
  const {
    buttonContainer,
    popoverContainer,
    config,
    isFullScreen,
    mainUIVisible
  } = props;
  const {
    onPopoverVisibilityChange,
    speedEnabled
  } = config;
  const {
    isPopoverOpen,
    setVisibility,
    closePopover,
    togglePopover
  } = useVisibility(onPopoverVisibilityChange, mainUIVisible);
  const qualityState = useQuality(props, closePopover);
  const {
    playbackRate,
    setPlaybackRate
  } = usePlaybackRate(props, closePopover);
  const shouldRender = Boolean(qualityState || speedEnabled);
  useOutsideClick(popoverContainer, buttonContainer, isPopoverOpen, () => setVisibility(false));
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: {
      config,
      playbackRate,
      setPlaybackRate,
      qualityState
    }
  }, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(SettingsButton, {
    onClick: togglePopover,
    big: isFullScreen
  }), buttonContainer), /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(SettingsPopover, {
    isOpen: isPopoverOpen
  }), popoverContainer));
};
//# sourceMappingURL=ModuleUI.js.map